export default {
    methods: {
        jq() {
            let productCategories = [
                {
                    title: 'Украшения',
                    id: 0
                },
                {
                    title: 'Камнерезные изделия',
                    id: 1
                },
                {
                    title: 'Столовые приборы',
                    id: 2
                },
                {
                    title: 'Письменные предметы',
                    id: 3
                },
                {
                    title: 'Часы',
                    id: 4
                },
                {
                    title: 'Предметы интерьера',
                    id: 5
                },
                {
                    title: 'Аксессуары',
                    id: 6
                },
                {
                    title: 'Нумизматика',
                    id: 7
                }
            ]
            let productTypes = [
                {
                    title: 'Кольцо',
                    id: 1,
                    category_id: 0
                },
                {
                    title: 'Серьги',
                    id: 2,
                    category_id: 0
                },
                {
                    title: 'Браслет',
                    id: 3,
                    category_id: 0
                },
                {
                    title: 'Цепь',
                    id: 4,
                    category_id: 0
                },
                {
                    title: 'Брошь',
                    id: 5,
                    category_id: 0
                },
                {
                    title: 'Шейное украшение',
                    id: 6,
                    category_id: 0
                },
                {
                    title: 'Подвеска',
                    id: 7,
                    category_id: 0
                },
                {
                    title: 'Пирсинг',
                    id: 8,
                    category_id: 0
                },
                {
                    title: 'Ложка',
                    id: 9,
                    category_id: 2
                },
                {
                    title: 'Вилка',
                    id: 10,
                    category_id: 2
                },
                {
                    title: 'Нож',
                    id: 11,
                    category_id: 2
                },
                {
                    title: 'Столовый набор',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Стопка',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Лопатка',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Блюдце',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Тарелка',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Чашка',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Бокал',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Кувшин',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Рюмка',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Кружка',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Кубок',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Блюдо',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Поднос',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Супница',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Стакан',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Розетка',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Набор',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Ваза',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Ковш',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Чайник',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Кофейник',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Турка',
                    id: 0,
                    category_id: 2
                },
                {
                    title: 'Часы',
                    id: 0,
                    category_id: 4
                },
                {
                    title: 'Рамка',
                    id: 0,
                    category_id: 5
                },
                {
                    title: 'Подсвечник',
                    id: 0,
                    category_id: 5
                },
                {
                    title: 'Шкатулка',
                    id: 0,
                    category_id: 5
                },
                {
                    title: 'Икона',
                    id: 0,
                    category_id: 5
                },
                {
                    title: 'Бонбоньерка',
                    id: 0,
                    category_id: 5
                },
                {
                    title: 'Ювелирная пластика',
                    id: 0,
                    category_id: 5
                },
                {
                    title: 'Подставка',
                    id: 0,
                    category_id: 5
                },
                {
                    title: 'Сувенир',
                    id: 0,
                    category_id: 5
                },
                {
                    title: 'Запонки',
                    id: 0,
                    category_id: 6
                },
                {
                    title: 'Зажим',
                    id: 0,
                    category_id: 6
                },
                {
                    title: 'Заколка',
                    id: 0,
                    category_id: 6
                },
                {
                    title: 'Шнурок',
                    id: 0,
                    category_id: 6
                },
                {
                    title: 'Брелок',
                    id: 0,
                    category_id: 6
                },
                {
                    title: 'Закладка',
                    id: 0,
                    category_id: 6
                },
                {
                    title: 'Наперсток',
                    id: 0,
                    category_id: 6
                },
                {
                    title: 'Фляжка',
                    id: 0,
                    category_id: 6
                },
                {
                    title: 'Футляр',
                    id: 0,
                    category_id: 6
                },
                {
                    title: 'Пуговица',
                    id: 0,
                    category_id: 6
                },
                {
                    title: 'Монета',
                    id: 0,
                    category_id: 7
                },
                {
                    title: 'Медаль',
                    id: 0,
                    category_id: 7
                },
                {
                    title: 'Значок',
                    id: 0,
                    category_id: 7
                }
            ]
            let productMaterial = [
                {
                    title: 'Белое золото',
                    id: 0
                },
                {
                    title: 'Желтое золото',
                    id: 1
                },
                {
                    title: 'Красное золото',
                    id: 2
                },
                {
                    title: 'Черное золото',
                    id: 3
                },
                {
                    title: 'Серебро',
                    id: 4
                },
                {
                    title: 'Платина',
                    id: 5
                },
                {
                    title: 'Палладий',
                    id: 6
                },
                {
                    title: 'Сталь',
                    id: 7
                },
                {
                    title: 'Титан',
                    id: 8
                },
                {
                    title: 'Латунь',
                    id: 9
                },
                {
                    title: 'Керамика',
                    id: 10
                },
                {
                    title: 'Дерево',
                    id: 11
                },
                {
                    title: 'Кожа',
                    id: 12
                },
                {
                    title: 'Синтетические материалы',
                    id: 13
                },
                {
                    title: 'Смешанные',
                    id: 14
                }
            ]
            let productStandart = [
                {
                    title: '375',
                    id: 0,
                    material_id: 1
                },
                {
                    title: '500',
                    id: 0,
                    material_id: 1
                },
                {
                    title: '585',
                    id: 0,
                    material_id: 1
                },
                {
                    title: '750',
                    id: 0,
                    material_id: 1
                },
                {
                    title: '875',
                    id: 0,
                    material_id: 1
                },
                {
                    title: '916',
                    id: 0,
                    material_id: 1
                },
                {
                    title: '958',
                    id: 0,
                    material_id: 1
                },
                {
                    title: '999',
                    id: 0,
                    material_id: 1
                },
                {
                    title: '925',
                    id: 0,
                    material_id: 4
                },
                {
                    title: '800',
                    id: 0,
                    material_id: 4
                },
                {
                    title: '830',
                    id: 0,
                    material_id: 4
                },
                {
                    title: '875',
                    id: 0,
                    material_id: 4
                },
                {
                    title: '900',
                    id: 0,
                    material_id: 4
                },
                {
                    title: '960',
                    id: 0,
                    material_id: 4
                },
                {
                    title: '585',
                    id: 0,
                    material_id: 5
                },
                {
                    title: '850',
                    id: 0,
                    material_id: 5
                },
                {
                    title: '900',
                    id: 0,
                    material_id: 5
                },
                {
                    title: '950',
                    id: 0,
                    material_id: 5
                },
                {
                    title: '500',
                    id: 0,
                    material_id: 6
                },
                {
                    title: '850',
                    id: 0,
                    material_id: 6
                }
            ]
            let productInsertion = [
                {
                    title: 'Цвет вставки',
                    options: [
                        'Белый',
                        'Бесцветный',
                        'Голубой',
                        'Желтый',
                        'Зеленый',
                        'Коричневый',
                        'Красный',
                        'Малиновый',
                        'Смешанный',
                        'Оранжевый',
                        'Розовый',
                        'Синий',
                        'Фиолетовый',
                        'Черный'
                    ]
                },
                {
                    title: 'Форма огранки',
                    options: [
                        'Круглая',
                        'Принцесса',
                        'Груша',
                        'Изумрудная',
                        'Маркиз',
                        'Овал',
                        'Багет',
                        'Бриолет',
                        'Фантазийная',
                        'Сердце',
                        'Овал',
                        'Кушон',
                        'Ашер',
                        'Триллиант',
                        'Кабашон',
                        'Радиант',
                        'Подушка'
                    ]
                }
            ]

            function onlyUnique(value, index, self) {
                return self.indexOf(value) === index
            }

            //Заполнение селектов Материалы
            productMaterial.forEach(function(material) {
                window
                    .$('.js-product-material')
                    .append('<option selected>' + material.title + '</option>')
            })

            //Заполнение селектов Проба
            var standartMaterialsUnique = productStandart
                .map(function(standart) {
                    return standart.material_id
                })
                .filter(onlyUnique)

            productMaterial.forEach(function(material) {
                if (standartMaterialsUnique.indexOf(material.id) >= 0) {
                    window
                        .$('.js-product-standart')
                        .append(
                            '<optgroup label="' +
                                material.title +
                                '" data-material-id="' +
                                material.id +
                                '"></optgroup>'
                        )
                }
            })

            productStandart.forEach(function(standart) {
                window
                    .$(
                        '.js-product-standart optgroup[data-material-id="' +
                            standart.material_id +
                            '"]'
                    )
                    .append('<option selected>' + standart.title + '</option>')
            })

            //Заполнение селектов Вставка
            productInsertion.forEach(function(insertion) {
                var options = ''
                insertion.options.forEach(function(option) {
                    options += '<option selected>' + option + '</option>'
                })
                window
                    .$('.js-product-insertion')
                    .append(
                        '<optgroup label="' +
                            insertion.title +
                            '" >' +
                            options +
                            '</optgroup>'
                    )
            })

            //Заполнение селектов Категория
            productCategories.forEach(function(category) {
                window
                    .$('.js-product-category')
                    .append('<option selected>' + category.title + '</option>')
            })

            //Заполнение селектов Вид изделия
            productTypes.forEach(function(type) {
                window
                    .$('.js-product-type')
                    .append('<option selected>' + type.title + '</option>')
            })

            //init after options is added
            window.$('.js-selectpicker').selectpicker({
                selectedTextFormat: 'count',
                countSelectedText: function(numSelected, numTotal) {
                    return numSelected === numTotal
                        ? this.title + ' Все'
                        : this.title + ' ' + numSelected
                }
            })

            var filters

            var mainFilters = [
                {
                    title: 'Материал',
                    id: 0,
                    options: []
                },
                {
                    title: 'Проба',
                    id: 1,
                    options: []
                },
                {
                    title: 'Вставка',
                    id: 2,
                    options: []
                },
                {
                    title: 'Производитель',
                    id: 3,
                    options: [
                        {
                            title: 'Sasonko',
                            id: 0,
                            checked: false
                        },
                        {
                            title: 'Русские самоцветы',
                            id: 1,
                            checked: false
                        }
                    ]
                }
            ]

            var supplierFilters = [
                {
                    title: 'Категория',
                    id: 0,
                    options: []
                },
                {
                    title: 'Вид изделия',
                    id: 1,
                    options: []
                },
                {
                    title: 'Материал',
                    id: 2,
                    options: []
                }
            ]

            productMaterial.forEach(function(material) {
                mainFilters[0]['options'].push({
                    title: material.title,
                    id: material.id,
                    checked: true
                })

                supplierFilters[2]['options'].push({
                    title: material.title,
                    id: material.id,
                    checked: true
                })
            })

            productStandart.forEach(function(standart) {
                mainFilters[1]['options'].push({
                    title: standart.title,
                    id: standart.id,
                    checked: true,
                    group_title: productMaterial.filter(function(material) {
                        return material.id === standart.material_id
                    })[0].title
                })
            })

            productInsertion.forEach(function(insertion) {
                insertion.options.forEach(function(option, i) {
                    mainFilters[2]['options'].push({
                        group_title: insertion.title,
                        title: option,
                        id: i,
                        checked: true
                    })
                })
            })

            productCategories.forEach(function(category) {
                supplierFilters[0]['options'].push({
                    title: category.title,
                    id: category.id,
                    checked: true
                })
            })

            productTypes.forEach(function(type) {
                supplierFilters[1]['options'].push({
                    title: type.title,
                    id: type.id,
                    checked: true
                })
            })

            var pathname = window.location.pathname.split('/')[1]

            if (pathname === 'supplier-products.html') {
                filters = supplierFilters
            } else {
                filters = mainFilters
            }

            filters.forEach(function(item) {
                window
                    .$('.js-mobile-filter-list')
                    .append(
                        '<li class="mobile-filter__list-item" data-value="' +
                            item.id +
                            '">' +
                            item.title +
                            '<div class="mobile-filter__selected-text"></div>' +
                            '</li>'
                    )
            })

            function getFiltersCount() {
                var count = 0

                filters.forEach(function(filter) {
                    filter.options.forEach(function(option) {
                        if (option.checked) count++
                    })
                })

                return count
            }

            function openMobileFilter() {
                window
                    .$('#mobile-filter-level1')
                    .addClass('mobile-filter--open')
            }

            window.$('.category__select-btn').click(function() {
                filters = mainFilters
                openMobileFilter()
            })
            window.$('.cabinet-btn--supplier-filter').click(function() {
                filters = supplierFilters
                openMobileFilter()
            })

            window
                .$('.mobile-filter__close-btn, #show-filtered-btn')
                .click(function() {
                    window
                        .$('#mobile-filter-level1')
                        .removeClass('mobile-filter--open')
                })

            var $filter1Item = window.$(
                '#mobile-filter-level1 .mobile-filter__list-item'
            )
            var $filter2 = window.$('#mobile-filter-level2')
            var $filter2Title = window.$(
                '#mobile-filter-level2 .mobile-filter__title'
            )
            var $filter2List = window.$(
                '#mobile-filter-level2 .mobile-filter__list'
            )
            var $clrbtn = window.$('#mobile-filter__clrbtn')

            //Открыть окно с чекбоксами
            window.$($filter1Item).click(function() {
                var filterId = window.$(this).attr('data-value')
                var filterObj = filters.filter(function(item) {
                    return item.id == filterId
                })[0]

                window
                    .$($filter2Title)
                    .html(filterObj.title)
                    .attr('data-value', filterObj.id)
                window.$($filter2List).html('')

                //если имеется подгруппа
                var groups = []
                if (filterObj.options[0].group_title) {
                    groups = filterObj.options
                        .map(function(option) {
                            return option.group_title
                        })
                        .filter(onlyUnique)

                    groups.forEach(function(group) {
                        window
                            .$($filter2List)
                            .append(
                                '<li class="mobile-filter__list-item">' +
                                    '<label class="custom-checkbox mobile-filter__list-item--title">' +
                                    group +
                                    '</label>' +
                                    '</li>'
                            )

                        filterObj.options.forEach(function(option) {
                            if (option.group_title === group) {
                                var isChecked = option.checked ? 'checked' : ''
                                window
                                    .$($filter2List)
                                    .append(
                                        '<li class="mobile-filter__list-item">' +
                                            '<label class="custom-checkbox">' +
                                            option.title +
                                            '<input type="checkbox" value="' +
                                            option.id +
                                            '" ' +
                                            isChecked +
                                            '>' +
                                            '<span class="custom-checkbox__checkmark"></span>' +
                                            '</label>' +
                                            '</li>'
                                    )
                            }
                        })
                    })
                } else {
                    filterObj.options.forEach(function(option) {
                        var isChecked = option.checked ? 'checked' : ''
                        window
                            .$($filter2List)
                            .append(
                                '<li class="mobile-filter__list-item">' +
                                    '<label class="custom-checkbox">' +
                                    option.title +
                                    '<input type="checkbox" value="' +
                                    option.id +
                                    '" ' +
                                    isChecked +
                                    '>' +
                                    '<span class="custom-checkbox__checkmark"></span>' +
                                    '</label>' +
                                    '</li>'
                            )
                    })
                }

                window.$($filter2).addClass('mobile-filter--open')
            })

            //возврат в окно с категориями фильтров
            window.$('#show-options-btn').click(function() {
                var activeFilterId = window.$($filter2Title).attr('data-value')
                var checkedArr = []

                window
                    .$($filter2)
                    .find('input[type=checkbox]:checked')
                    .each(function() {
                        checkedArr.push(parseInt(this.value))
                    })

                var $selectedText = window
                    .$(
                        '.mobile-filter__list-item[data-value=' +
                            activeFilterId +
                            ']'
                    )
                    .find('.mobile-filter__selected-text')
                window.$($selectedText).html('')
                var textStr = ''

                filters.forEach(function(filter) {
                    if (filter.id == activeFilterId) {
                        filter.options.forEach(function(option) {
                            option.checked = checkedArr.indexOf(option.id) >= 0
                            textStr += option.checked ? option.title + ', ' : ''
                        })
                    }
                })

                window
                    .$($selectedText)
                    .append(textStr.substring(0, textStr.length - 2))

                window
                    .$('.mobile-filter__selected-count')
                    .html('(' + getFiltersCount() + ')')
                getFiltersCount() === 0
                    ? window.$($clrbtn).addClass('hide')
                    : window.$($clrbtn).removeClass('hide')

                window.$($filter2).removeClass('mobile-filter--open')
            })

            window.$('.mobile-filter__back-btn').click(function() {
                window.$($filter2).removeClass('mobile-filter--open')
            })

            window.$('.mobile-filter__btn--clear').click(function() {
                filters.forEach(function(filter) {
                    filter.options.forEach(function(option) {
                        option.checked = false
                    })
                })
                window.$('.mobile-filter__selected-count').html('')
                window.$('.mobile-filter__selected-text').html('')
                window.$($clrbtn).addClass('hide')
            })

            setTimeout(function() {
                window.$('.mobile-filter').removeClass('hide')
            }, 500)
        }
    }
}
